import { render, staticRenderFns } from "./vpl-form-modal.vue?vue&type=template&id=6ded08f3&scoped=true&"
import script from "./vpl-form-modal.vue?vue&type=script&lang=js&"
export * from "./vpl-form-modal.vue?vue&type=script&lang=js&"
import style0 from "./vpl-form-modal.vue?vue&type=style&index=0&id=6ded08f3&lang=scss&scoped=true&"
import style1 from "./vpl-form-modal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ded08f3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VWindow } from 'vuetify/lib/components/VWindow';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSelect,VSpacer,VWindow,VWindowItem})
